/**
 * Money and currency utility functions for formatting and handling monetary values.
 */

/**
 * Formats a monetary value to two decimal places.
 * @param {string|number|null} value - The value to format.
 * @returns {number|null} The formatted value as a float with 2 decimal places, or null if invalid.
 */
export function formatMoneyValue(value) {
    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue)) {
        return parseFloat(parsedValue.toFixed(2));
    }
    return null;
}